import { createSlice } from "@reduxjs/toolkit";
import { totalDonationCampCount } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const totalCountSlice = createSlice({
  name: "totalCount",
  initialState: data,
  reducers: {
    totalCountSlice(state) {
      state.isLoading = false;
    },
    totalCountSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    totalCountSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    totalCountSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const totalCountHandler = () => async (dispatch: any) => {
  try {
    dispatch(totalCountAction.totalCountSlice());
    const response: any = await totalDonationCampCount();
    dispatch(totalCountAction.totalCountSliceSuccess(response));
  } catch (e: any) {
    dispatch(totalCountAction.totalCountSliceFailure(e?.response?.data?.message));
    dispatch(totalCountAction.totalCountSliceReset());
  }
};
export default totalCountSlice.reducer;
export const totalCountAction = totalCountSlice.actions;
